import { render } from "./EmailOTPVerification.vue?vue&type=template&id=3a724168"
import script from "./EmailOTPVerification.vue?vue&type=script&lang=js"
export * from "./EmailOTPVerification.vue?vue&type=script&lang=js"

import "./EmailOTPVerification.vue?vue&type=style&index=0&id=3a724168&lang=css"
script.render = render

export default script